import React from "react";

function PunjabTimeline() {
  return (
    <div>
      <h2 className="text-h-orange py-5">
        “Upon entry to jail, prisoners are asked how they identified according
        to caste, and if [a person from a minority faith] provided association
        such as <i>jat</i> or <i>malik</i>, which is a common way of
        identification in Pakistan, they would be told, ‘no, you are [from the
        minority faith.]’ [Our faith] becomes our caste… for us religion is
        noted in place of caste.”
      </h2>
      <div className="row row-cols-1 row-cols-md-2 g-4">
        <div className="col">
          <p>- Ex-prisoner Farooq</p>
          <img
            style={{ width: "70%" }}
            src={require("../../assets/images/Ibbetson-Punjab-map.jpg")}
            alt="Ibbetson-Punjab-Map"
          />

          <br />
          <br />
          <br />
          <br />
          <br />
          <h2 className="text-h-black">
            Detention Through Colonial and Post-Colonial Times
          </h2>
          <br />
          <br />
          <br />
          <br />
          <br />
          <img
            style={{ width: "80%" }}
            src={require("../../assets/images/Punjab-timeline-02.jpg")}
            alt="Punjab-timeline-02"
          />
        </div>
        <div className="col">
          <div>
            <br />
            <p>
              In undivided Punjab, Sir Denzil Ibbetson, a member of the Bengal
              Civil Service under the Crown rule of India, compiled a document
              that drew heavily from the 1881 census report. Called the{" "}
              <a href="https://babel.hathitrust.org/cgi/pt?id=ucbk.ark:/28722/h2qm8w&view=1up&seq=13">
                <i>Outlines of Panjab Ethnography</i>
              </a>
              , it included categorised lists and detailed descriptions – of all
              the occupational groups, races, castes, tribes, religions, and
              languages – that he believed comprised empirical knowledge of the
              region. For future administrators to be able to make real sense of
              the numbers, he wanted to annotate the “voluminous table of naked
              figures“ that would “furnish a sketch of the salient features of
              native societies in the Panjab.”
            </p>
            <br />
            <p>
              Ibbetson mapped the province into distinct, enumerated
              religio-ethnic portions, as if its very topography was cartography
              for the racial, cultural, linguistic, and tribal myriad he hoped
              to classify.
            </p>
          </div>
          <div>
            <div className="mt-5">
              <div className="d-flex">
                <div className="position-relative">
                  <div className="box-style"></div>
                </div>
                <div>
                  <h2 className="text-h-orange">Undivided Punjab</h2>
                  <p>
                    In Punjab the forms of discrimination and criminalisation
                    that sectarian and religious minority groups face can be
                    traced back to colonial anthropological practices of
                    topographically identifying people of the region by
                    religion.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <div className="d-flex">
                <div className="position-relative">
                  <div className="box-style"></div>
                </div>
                <div>
                  <h2 className="text-h-orange">Post-Partition</h2>
                  <p>
                    Following Partition, the influx of Muslim refugees and the
                    departure of Hindus and Sikhs for India resulted in
                    demographic changes that saw Sunnis become the vast
                    majority, and a majoritarian Sunni identity was also
                    fomented.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <div className="d-flex">
                <div className="position-relative">
                  <div className="box-style"></div>
                </div>
                <div>
                  <h2 className="text-h-orange">The Present</h2>
                  <p>
                    Today, while socio-economic disenfranchisement is a major
                    reason for high incarceration rates across the country, in
                    Punjab, the back-story to much of the criminal activity that
                    defence lawyers sift through, such as murder and robbery,
                    take place as a result of community-based tussles over
                    limited resources. For those members of the working class
                    who belong to minority backgrounds the situation is even
                    worse. They are vulnerable to the scapegoating of their
                    identities as being in violation of the majority faith,
                    which becomes the platform on which to dispute rights to
                    employment, property, and political participation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PunjabTimeline;
